<template>
  <div class="deposit-iframe-page">
    <div class="nav-bar">
      <i
        @click="backHandle"
        class="el-icon-back icon-btn pointer"></i>
      <span
        @click="backHandle"
        class="pointer">{{$t('Train.back')}}{{$t('User.monChan')}}</span>
    </div>
    <div
      v-loading="loading"
      class="deposit-iframe-page-content">
      <iframe
        style="height: 100%;width: 100%;min-height: 700px;"
        :src="src"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      loading: true
    }
  },
  computed:{
    src(){
      return this.$route.query.depositUrl;
    }
  },
  created(){
    setTimeout(() => {
      this.closeLoading();
    },1800);
  },
  mounted(){
    let reouterview = document.getElementById('routerview');
    reouterview.classList.add('no-padding-import');
  },
  beforeDestroy(){
    let reouterview = document.getElementById('routerview');
    reouterview && reouterview.classList.remove('no-padding-import');
  },
  methods: {
    backHandle() {
      this.$router.push({name: 'depositFunds'});
    },
    closeLoading(){
      this.loading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.deposit-iframe-page {
  .nav-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    .icon-btn {
      font-size: 16px;
    }
  }
}
</style>
